import React from 'react';

const ResetPasswordPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: true,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      auth: null,
      path: '/pages/auth/reset-password',
      component: React.lazy(() => import('./ResetPasswordPage')),
    },
  ],
};

export default ResetPasswordPageConfig;
